






















































































































import Component, { mixins } from 'vue-class-component';
import { loadView, loadWidget } from '@/utils/helpers';
import { namespace } from 'vuex-class';
import { IAutocreditAccount, IAutocreditAccountBody, IOrganizations, IPaginate } from '@/types/types';
import timestamp from '@/filters/timestamp';
import { Watch } from 'vue-property-decorator';
import WidgetMixins from '@/mixins/WidgetMixins';
import DialogMixins from '@/mixins/DialogMixins';
import qs from 'qs';

const autocreditModule = namespace('autocredit');
const organizationModule = namespace('organizations');

@Component({
  name: 'AutocreditBankDetails',
  components: {
    InternetConnection: loadWidget('pages/InternetConnection'),
    ToolBar: loadWidget('widgets/ToolBar'),
    SnackBar: loadWidget('widgets/SnackBar'),
    EmptyPage: loadWidget('pages/EmptyPage'),
    AutocreditBankDetailsDialog: loadView('pages/products/dialogs/AutocreditBankDetailsDialog'),
  },
  filters: {
    timestamp,
  },
})
export default class AutocreditBankDetails extends mixins(WidgetMixins, DialogMixins) {
  @autocreditModule.Getter('getAccounts') accounts!: IAutocreditAccount[];
  @autocreditModule.Getter('getAccountsPagination') accountsPagination!: IPaginate;
  @organizationModule.Getter('getAllOrganizations') organizations!: IOrganizations[];

  options: any = {};
  query: string = '';
  organizationId: string | null = null;
  editingAccount: IAutocreditAccount | null = null;

  headers: Array<{ text: string; value: string; align?: string; sortable?: boolean }> = [
    { text: 'Organization', value: 'organizationName' },
    { text: 'Account Number', value: 'accountId' },
    { text: 'Sort Code', value: 'sortCode' },
    { text: 'Transfer Type', value: 'transferType' },
    { text: 'MSISDN', value: 'msisdn' },
    { text: 'Autocrediting', value: 'autocreditEnabled' },
    { text: 'Status', value: 'status' },
    { text: 'Updated', value: 'updatedAt' },
    { text: '', value: 'actions', sortable: false },
  ];

  organizationName(account: IAutocreditAccount): string {
    const organization = this.organizations.find(({ _id }) => _id === String(account.organizationId));
    return organization?.name ?? '—';
  }

  openAddDialog(account: IAutocreditAccount | null = null): void {
    this.editingAccount = account;
    this.open('add');
  }

  handleSave(body: IAutocreditAccountBody): void {
    this.$store.dispatch('autocredit/upsertAccount', { body, query: this.query });
  }

  fetchAccounts(): void {
    this.$store.dispatch('autocredit/fetchAccounts', this.query);
  }

  @Watch('organizationId')
  onOrganizationIdChange(value: string): void {
    const parsed = qs.parse(this.query, { ignoreQueryPrefix: true });
    this.query = qs.stringify({ ...parsed, organizationId: value }, { skipNulls: true, addQueryPrefix: true });
    this.fetchAccounts();
  }

  @Watch('options', { deep: true })
  onOptionsChange(paginate: IPaginate): void {
    const qParams = {
      page: paginate.page,
      limit: paginate.itemsPerPage,
      organizationId: this.organizationId,
    };
    const query = qs.stringify(qParams, { skipNulls: true, addQueryPrefix: true });
    if (query === this.query) return;
    this.query = query;
    this.fetchAccounts();
  }

  created(): void {
    this.$store.dispatch('organizations/list', false);
    this.query = qs.stringify({ page: 1, limit: 50 }, { addQueryPrefix: true });
    this.fetchAccounts();
  }
}
